module.exports = __webpack_public_path__ + "media/images/amenities_icons/plug-in-for-electric-cars-1fa8d3842520b658543be3c5f6b92fa4.svg";